import { useEffect } from 'react';

export default function useResetScrollPosition() {
    useEffect(() => {
        window.scroll({ top: 0 });
    }, [])
}